/**
 * addToFavorites - This function determines if the same element already exists in the local storage or in the favorites array.
 * If yes, instead of adding, the element is removed. It acts as a toggle (add or remove).
 * If there is no amtch, the item is added to the favorites array and saved to the local storage.
 * @param {item} item - Object being added or removed
 * @param {favorites} favorites - Array of object favorites
 * @return {y}
 **/
export function addToFavorites(item, favorites) {
  let obj;

  for (let index = 0; index < favorites.length; index++) {
    obj = favorites[index];

    if (
      //
      obj.name === item.name && //
      obj.objectName === item.objectName && //
      obj.sn === item.sn && //
      obj.stationId === item.stationId && //
      obj.unitId === item.unitId
    ) {
      favorites.splice(index, 1);
      localStorage.setItem("favorite", JSON.stringify(favorites));
      return;
    }
  }
  favorites.push(item);
  localStorage.setItem("favorite", JSON.stringify(favorites));
}

/**
 * loadFavorites - If the favorite key exists in the local store and this key is nonzero, then it returns the parsed contents as a return array
 * @return {y} - Array of favorite items
 **/
export function loadFavorites() {
  let favorite = [];

  if (localStorage.getItem("favorite") !== null) {
    favorite = JSON.parse(localStorage.getItem("favorite"));
  }

  return favorite;
}

/**
 * getFavoriteColor - Each element is searched. If it is part of the favorites, it will return red color if not return grey
 * @param {item} item - Element
 * @param {favorites} favorites - Array of object favorites
 * @return {color} red or grey
 **/
export function getFavoriteColor(item, favorites) {
  for (let index = 0; index < favorites.length; index++) {
    if (
      //
      favorites[index].name === item.name && //
      favorites[index].objectName === item.objectName && //
      favorites[index].sn === item.sn && //
      favorites[index].stationId === item.stationId && //
      favorites[index].unitId === item.unitId
    ) {
      return "red";
    }
  }
  return "grey";
}

/* export function isFavorite(array1, array2) { */
/*   array1.forEach((obj1) => {
    if (obj1.sn === array2.sn) {
      return true;
    }
  }); */
/*   for (let index = 0; index < favorites.length; index++) {
    if (
      //
      favorites[index].name === item.name && //
      favorites[index].objectName === item.objectName && //
      favorites[index].sn === item.sn && //
      favorites[index].stationId === item.stationId && //
      favorites[index].unitId === item.unitId
    ) {
      return "red";
    }
  }
  return "grey"; */
/* } */
